import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: "root"
})
export class ProspectFormService {
  private urlCep =
    "https://webmaniabr.com/api/1/cep/";
  private appKey = "app_key=PtFuhkCjHWxSs47fcDQQGQu4yfzY4o40";
  private appSecret = "app_secret=3NvQsgBu16M5wRO2y04xU7WhJ8ZubEVKpzx36nb7raPGUIU0";
  private urlProspect = `${environment.API}prospect`;

  constructor(private http: HttpClient) {}

  getEndereco(cep: String): Observable<any> {
    return this.http.get(this.urlCep + cep+"/?"+  this.appKey+"&"+ this.appSecret );
  }

  SalvarCadastro(prospect: Array<any>): Observable<any> {
    return this.http.post(this.urlProspect,prospect);
  }

}
